module.exports = __webpack_public_path__ + "static/media/space-bar-icon.a71a4230.png";